/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { AppPipeline, PipelineType } from "API";
import { ternary } from "assets/js/utils";
import HeaderWithValueLabel from "pages/comps/HeaderWithValueLabel";
import { ServiceLogDetailProps } from "pages/dataInjection/serviceLog/ServiceLogDetail";
import React from "react";
import { useTranslation } from "react-i18next";

interface LifecycleLightEngineProps {
  pipelineType: PipelineType;
  servicePipeline?: ServiceLogDetailProps;
  appPipeline?: AppPipeline;
}
const LifecycleLightEngine: React.FC<LifecycleLightEngineProps> = ({
  pipelineType,
  servicePipeline,
  appPipeline,
}) => {
  const { t } = useTranslation();
  return (
    <HeaderWithValueLabel
      numberOfColumns={3}
      headerTitle={t("pipeline.detail.lifeCycle")}
      dataList={[
        {
          label: t("pipeline.detail.logArchive"),
          data: ternary(
            pipelineType === PipelineType.APP,
            appPipeline?.lightEngineParams?.logArchiveAge,
            servicePipeline?.logArchiveAge
          ),
        },
      ]}
    />
  );
};

export default LifecycleLightEngine;
